import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { Box, IconButton } from '@mui/material';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import LoadingScreen from './components/LoadingScreen';
import { Suspense, lazy } from 'react';

// Lazy load components
const DonationForm = lazy(() => import('./components/DonationForm'));
const Home = lazy(() => import('./components/Home'));
const DsfHistory = lazy(() => import('./components/DsfHistory'));
const About = lazy(() => import('./components/About'));
const History = lazy(() => import('./History'));
const ContactUs = lazy(() => import('./components/ContactUs'));
const Certificates = lazy(() => import('./components/Certificates'));
const MembershipForm = lazy(() => import('./components/MembershipForm'));
const FAQScreen = lazy(() => import('./components/FaQs'));
const SuccessStories = lazy(() => import('./components/SuccessStories'));
const Projects = lazy(() => import('./components/Projects'));
const Hospital = lazy(() => import('./Hospital'));
const Scholarships = lazy(() => import('./components/Scholarships'));
const Dispensaries = lazy(() => import('./components/Dispensaries'));
const FoodProjects = lazy(() => import('./components/FoodProjects'));
const Vocational = lazy(() => import('./components/Vocational'));
const NewsPage = lazy(() => import('./components/NewsPage'));
const OurTeam = lazy(() => import('./components/OurTeam'));
const Careers = lazy(() => import('./components/Careers'));
const NotFound = lazy(() => import('./NotFound'));

function App() {
  return (
    <Router>
      <Navbar />
      <Suspense fallback={<LoadingScreen />}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/history" element={<DsfHistory />} />
          <Route path="/certificates" element={<Certificates />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/stories" element={<SuccessStories />} />
          <Route path="/member" element={<MembershipForm />} />
          <Route path="/donate" element={<DonationForm />} />
          <Route path="/read" element={<History />} />
          <Route path="/volunteer" element={<MembershipForm />} />
          <Route path="/about" element={<About />} />
          <Route path="/faq" element={<FAQScreen />} />
          <Route path="/contact" element={<ContactUs />} />
          <Route path="/team" element={<OurTeam />} />
          <Route path="/news" element={<NewsPage />} />
          <Route path="/hospital" element={<Hospital />} />
          <Route path="/scholarships" element={<Scholarships />} />
          <Route path="/dispensaries" element={<Dispensaries />} />
          <Route path="/foodprojects" element={<FoodProjects />} />
          <Route path="/vocational" element={<Vocational />} />
          <Route path="/careers" element={<Careers />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Suspense>
      {/* WhatsApp sticky Button */}
      <Box sx={{
        position: 'fixed',
        bottom: '10px',
        right: '10px',
        zIndex: 1000
      }} >
        <IconButton color="primary"
          href="https://wa.me/+923307000718" target="_blank"
          sx={{
            backgroundColor: '#027D40',
            color: '#00ff55',
            boxShadow: '10px 10px 6px rgba(0, 0, 0, 0.3)'
          }} >
          <WhatsAppIcon style={{
            fontSize: { xs: 20, md: 40 }
          }} />
        </IconButton>
      </Box>
      <Footer />
    </Router>
  );
}

export default App;
